import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import PapaFutbolero from "./pages/landings/PapaFutbolero";
import ParaMama from "./pages/landings/ParaMama";
import Aficionado from "./pages/landings/Aficionado";
import Empresas from "./pages/landings/Empresas";
import PaymentConfirmation from "./pages/PaymentConfirmation";
import { trackPageView } from "./lib/analytics";

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    // Wait a tick so React updates document.title from page components first
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search, document.title);
    }, 0);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsTracker />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/papa-futbolero" element={<PapaFutbolero />} />
          <Route path="/para-mama" element={<ParaMama />} />
          <Route path="/aficionado" element={<Aficionado />} />
          <Route path="/empresas" element={<Empresas />} />
          <Route path="/payment-confirmation/:orderId" element={<PaymentConfirmation />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
